/**
 * @deprecated Import from '@/components/atoms' or '@/atoms' instead.
 * This file is kept for backwards compatibility during migration.
 */

export { Label, labelVariants } from '@/components/atoms/typography';
